import {useState} from 'react';
import {PageHeader, TabsComponent} from '@/components/molecules';
import {HeaderTitle} from '@/components/atoms';
import {Header} from '@/utils/constants/header';
import {PerfectStoreList} from '@/containers/PerfectStore/PerfectStoreList';

const tabList = [
  {
    id: 'perfect-store',
    tabLabel: 'Perfect Store',
    title: 'Perfect Store',
    tabComponent: <PerfectStoreList />
  },
  {
    id: 'store-groups',
    tabLabel: 'Store Groups',
    title: 'Store Groups',
    tabComponent: <div>Store Groups</div>
  },
  {
    id: 'product-groups',
    tabLabel: 'Product Groups',
    title: 'Product Groups',
    tabComponent: <div>Product Groups</div>
  }
];

export const PerfectStoreHome = () => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <div
      className='salesTargetsContainer flex flex-col'
      data-testid='perfect-store-home'>
      <PageHeader title='Perfect Store' />
      <div
        style={{
          backgroundColor: 'var(--color-background-layer-01)',
          paddingLeft: '16px'
        }}
        className='salesTargetsTitleSection relative'
        data-testid='perfect-store-list'>
        <HeaderTitle
          headingLevel={Header.SectionTitle}
          title={tabList[tabIndex]?.title}
          className='salesTargetsDataTableHeading'
        />
        <TabsComponent
          tabList={tabList}
          defaultTabIndex={0}
          onTabChange={setTabIndex}
        />
      </div>
    </div>
  );
};
